import { Component } from '@angular/core';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})


export class AppComponent {
  public static get baseURL(): string { return environment.API_URL.toString(); }

  public static get DownloadURL(): string { return environment.Download_URL.toString(); }

   }
